import { render, staticRenderFns } from "./MyFeedLabel.vue?vue&type=template&id=6b440f84&scoped=true&"
import script from "./MyFeedLabel.vue?vue&type=script&lang=js&"
export * from "./MyFeedLabel.vue?vue&type=script&lang=js&"
import style0 from "./MyFeedLabel.vue?vue&type=style&index=0&id=6b440f84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b440f84",
  null
  
)

export default component.exports